<template>
  <div class="main-content">
    <section class="section">
      
      <div class="section-body">

      </div>
    </section>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import api from "@/api";

//import VueSlickGrid from "ls-vue-slickgrid";

export default {
  title: "Dashboard",
  access_code: "HOME_04",
  order: 99,
  icon: "fas fa-chart-bar",
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    // ...mapGetters("grid", ["getGridById"]),
    // ...mapGetters(["getIsBlock"])
  },
  created() {
    
    this.$route.meta.access_code = "HOME";
    // this.actionSetForceBlock(false);
    
  },

  mounted() {
    this.actionSetUser({
      "user_id": this.$route.query.userID,
      "full_name": this.$route.query.fullName,
      "session_id":this.$route.query.sessionID,
      "access_name":this.$route.query.accessName,
      "locale_code":this.$route.query.language,
      });
      if(this.$route.query.type!=""&&this.$route.query.type!=null){
      this.$router.push("/Mobile/Forms/Form/Request/"+this.$route.query.formID+"?ISWORK_ID="+this.$route.query.type);
      }else{
        this.$router.push("/Mobile/Forms/Form/request?ISWORK_ID="+this.$route.query.type);
      }
  },
  methods: {
    // ...mapActions("grid", ["actionSetGridWithoutReload"]),
    // ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),
    ...mapActions(["actionSetMessage", "actionSetUser"]),

  }
};
</script>

